import { requireDashboardOrigin } from "@api/features/dashboard-auth/origin/dashboardOriginGuard"
import { serverRouteConfig } from "@server/server-route-config"
import { dashboardApiErrorMessage } from "@site-server/dashboard-api-errors"
import { createFileRoute } from "@tanstack/react-router"
import * as z from "zod"

const mfaInputSchema = z.object({
  code: z.string().min(1).max(128),
  type: z.enum(["otp", "recovery"]),
})

export const Route = createFileRoute("/api/dashboard/auth/mfa")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => {
          const originError = requireDashboardOrigin(request)
          if (originError) return originError

          try {
            const input = mfaInputSchema.parse(await request.json())
            const { completeDashboardMfa } = await import("@api/features/dashboard-auth/dashboardAuthApi")
            const result = await completeDashboardMfa(input, request)
            const headers = new Headers()
            for (const cookie of result.setCookies) headers.append("Set-Cookie", cookie)
            return Response.json(result.payload, { headers })
          } catch (error) {
            return Response.json(
              { error: dashboardApiErrorMessage(error, "Could not verify MFA code.") },
              { status: 401 }
            )
          }
        },
      },
    },
  })
)
